<template>
  <div class="lang-btn" @click="openList">
    <img :src="require(`@/assets/img/lang/${mapLang($i18n.locale).img}.png`)" alt="" />
  </div>
</template>

<script>
import { mapLang } from '@/setting'

export default {
  name: 'langSelectedBlock',
  props: {
    isOpenLang: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      isOpenList: false
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    /**
     * 開啟語系選單
     */
    openList() {
      this.isOpenList = this.isOpenLang
      this.isOpenList = !this.isOpenList
      this.$emit('getOpenLangStatus', this.isOpenList)
    },
    mapLang(lang = 'en_us') {
      return mapLang[lang]
    }
  }
}
</script>

<style lang="scss" scoped></style>
